/* eslint-disable react/prop-types */

import React  from 'react';

function MappedLabel(props) {
    return <>{props.map.get(props.value) || ''}</>;
}

export { MappedLabel };
